/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationPipelineConfigUpdatePathParams,
	OrganisationPipelineConfigUpdateRequest,
	OrganisationPipelineConfigUpdateResponse,
} from '../types/OrganisationPipelineConfigUpdate'

/**
 * PUT /organisations/:organisation/pipeline-config
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::update
 */
export async function organisationPipelineConfigUpdate(
	organisation: OrganisationPipelineConfigUpdatePathParams['organisation'],
	data: OrganisationPipelineConfigUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPipelineConfigUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/pipeline-config`, data, config)
}
